import React, { useState } from 'react';
import './SinglePdfUpload.css';

function SinglePdfUpload({ onFileUpload, onBack }) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        onFileUpload(file);
      } else {
        alert('Please upload a PDF file');
      }
    }
  };

  const handleFileInput = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        onFileUpload(file);
      } else {
        alert('Please upload a PDF file');
      }
    }
  };

  return (
    <div className="single-pdf-upload">
      <div className="upload-header">
        <div>
          <h2>Create Order from Purchase Agreement</h2>
          <p className="upload-subtitle">Upload a purchase agreement PDF to automatically extract and pre-fill title order information</p>
        </div>
      </div>

      <div
        className={`drop-zone ${isDragging ? 'dragging' : ''}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div className="drop-zone-content">
          <div className="upload-icon">📄</div>
          <h3>Drag and drop your purchase agreement here</h3>
          <p className="drop-zone-subtitle">or</p>
          <label htmlFor="file-input" className="upload-button">
            Browse Files
          </label>
          <input
            id="file-input"
            type="file"
            accept=".pdf"
            onChange={handleFileInput}
            style={{ display: 'none' }}
          />
          <p className="file-info">Accepts PDF files only</p>
        </div>
      </div>

      <div className="process-info">
        <h3>How it works:</h3>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Upload Document</h4>
              <p>Drag and drop or browse for your purchase agreement PDF</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>AI Analysis</h4>
              <p>Multiple AI providers extract and verify property and order information</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Review Results</h4>
              <p>Compare AI consensus side-by-side and edit any fields as needed</p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h4>Submit Order</h4>
              <p>Send validated data directly to SoftPro for order creation</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SinglePdfUpload;
